module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": ""
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("add")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, _vm._l((_vm.dokumentArten), function(item, index) {
    return _c('v-list-item', {
      key: index,
      attrs: {
        "link": ""
      },
      on: {
        "click": function($event) {
          (_vm.showNeuesDokument = true) &&
          (_vm.neuesDokument = _vm.neuesDokumentDefault) &&
          (_vm.neuesDokument.art = item.value) &&
          (_vm.isNew = true)
        }
      }
    }, [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(item.titel))]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v(_vm._s(item.beschreibung))])], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Suchen",
      "single-line": "",
      "solo": "",
      "flat": "",
      "hide-details": "",
      "clearable": "",
      "clear-icon": "close"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-chip', {
    attrs: {
      "small": "",
      "label": "",
      "color": "green",
      "dark": ""
    }
  }, [_vm._v("BETA")])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "ma-0"
  }, _vm._l((_vm.dokumente), function(item, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "4"
      }
    }, [_c('v-card', {
      staticClass: "rounded-lg",
      attrs: {
        "outlined": ""
      }
    }, [_c('v-card-title', [_vm._v("\n          " + _vm._s(item.titel) + "\n        ")]), _vm._v(" "), _c('v-card-subtitle', [_vm._v(_vm._s(_vm.dokumentArten.find(function (key) { return key.value === item.art; }).text))]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          (_vm.showNeuesDokument = true) && (_vm.neuesDokument = item) && (_vm.isNew = false)
        }
      }
    }, [_c('v-icon', [_vm._v("edit")])], 1), _vm._v(" "), _c('v-btn', {
      staticClass: "primary--text",
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          (_vm.neuesDokument = item) && (_vm.printDokument())
        }
      }
    }, [_c('v-icon', [_vm._v("download")])], 1), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1)
  }), 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "width": "70%",
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showNeuesDokument),
      callback: function($$v) {
        _vm.showNeuesDokument = $$v
      },
      expression: "showNeuesDokument"
    }
  }, [_c('v-card', [(_vm.isNew) ? _c('v-card-title', [_vm._v("\n        Neues Dokument erstellen\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showNeuesDokument = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1) : _c('v-card-title', [_vm._v("\n        " + _vm._s(_vm.neuesDokument.titel) + " bearbeiten\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showNeuesDokument = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "ma-0 pa-0"
  }, [_c('v-row', {
    staticClass: "ma-0 pa-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "label": "Titel"
    },
    model: {
      value: (_vm.neuesDokument.titel),
      callback: function($$v) {
        _vm.$set(_vm.neuesDokument, "titel", $$v)
      },
      expression: "neuesDokument.titel"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-select', {
    attrs: {
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "items": _vm.dokumentArten,
      "label": "Art"
    },
    model: {
      value: (_vm.neuesDokument.art),
      callback: function($$v) {
        _vm.$set(_vm.neuesDokument, "art", $$v)
      },
      expression: "neuesDokument.art"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [(_vm.neuesDokument.art === 'kommerseinladung') ? _c('span', [_vm._v("\n              Die Kommerseinladung ist eine 4 Seitige DIN-Lang Klappkarte. Es wird ein PDF mit zwei Seiten im Format \n              204 x 216 mm generiert. Auf der ersten Seite befindet sich die Vorder- und Rückseite und auf der zweiten \n              Seite der Innenteil. Die Text können frei angepasst werden. Enter zwischen den Worten sowie Leerzeilen \n              werden berücksichtigt.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.neuesDokument.art === 'tagesordnung') ? _c('span', [_vm._v("\n              Die Tagesordnung ist auf wird auf einer A4 Seite dargestellt. Dabei kann sowohl vor als auch nach den \n              Tagesordnungspunkten ein Freitext hinzugefügt werden.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.neuesDokument.art === 'rundbriefohneansprache') ? _c('span', [_vm._v("\n              Der Rundbrief kann eine oder mehrere A4-Seiten umfassen. Es wird keine Adresse der Bundesbrüder eingefügt. \n              Als Absender dient der ausgewählte Kontakt sowie das eingetragene Amt. Bei Mehrseitigen Dokumenten wird eine\n              Seitenzahl eingefügt.\n            ")]) : _vm._e()])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.neuesDokument.art === 'kommerseinladung') ? _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "label": "Titelzeile 1"
    },
    model: {
      value: (_vm.neuesDokument.data.titel1),
      callback: function($$v) {
        _vm.$set(_vm.neuesDokument.data, "titel1", $$v)
      },
      expression: "neuesDokument.data.titel1"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "label": "Titelzeile 2"
    },
    model: {
      value: (_vm.neuesDokument.data.titel2),
      callback: function($$v) {
        _vm.$set(_vm.neuesDokument.data, "titel2", $$v)
      },
      expression: "neuesDokument.data.titel2"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "label": "Titelzeile 3"
    },
    model: {
      value: (_vm.neuesDokument.data.titel3),
      callback: function($$v) {
        _vm.$set(_vm.neuesDokument.data, "titel3", $$v)
      },
      expression: "neuesDokument.data.titel3"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "label": "Titelzeile 4"
    },
    model: {
      value: (_vm.neuesDokument.data.titel4),
      callback: function($$v) {
        _vm.$set(_vm.neuesDokument.data, "titel4", $$v)
      },
      expression: "neuesDokument.data.titel4"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "label": "Untertitel 1"
    },
    model: {
      value: (_vm.neuesDokument.data.titel5),
      callback: function($$v) {
        _vm.$set(_vm.neuesDokument.data, "titel5", $$v)
      },
      expression: "neuesDokument.data.titel5"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "label": "Anschreiben"
    },
    model: {
      value: (_vm.neuesDokument.data.anschreiben),
      callback: function($$v) {
        _vm.$set(_vm.neuesDokument.data, "anschreiben", $$v)
      },
      expression: "neuesDokument.data.anschreiben"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "label": "Senior"
    },
    model: {
      value: (_vm.neuesDokument.data.senior),
      callback: function($$v) {
        _vm.$set(_vm.neuesDokument.data, "senior", $$v)
      },
      expression: "neuesDokument.data.senior"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "label": "Philsterenior"
    },
    model: {
      value: (_vm.neuesDokument.data.philsenior),
      callback: function($$v) {
        _vm.$set(_vm.neuesDokument.data, "philsenior", $$v)
      },
      expression: "neuesDokument.data.philsenior"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    staticClass: "pb-2",
    attrs: {
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "label": "Tag 1"
    },
    model: {
      value: (_vm.neuesDokument.data.tag1),
      callback: function($$v) {
        _vm.$set(_vm.neuesDokument.data, "tag1", $$v)
      },
      expression: "neuesDokument.data.tag1"
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "hint": "Veranstaltungspunkte mit Enter trennen.",
      "outlined": "",
      "dense": "",
      "label": "Tag 1 Programm"
    },
    model: {
      value: (_vm.neuesDokument.data.tag1programm),
      callback: function($$v) {
        _vm.$set(_vm.neuesDokument.data, "tag1programm", $$v)
      },
      expression: "neuesDokument.data.tag1programm"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    staticClass: "pb-2",
    attrs: {
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "label": "Tag 2"
    },
    model: {
      value: (_vm.neuesDokument.data.tag2),
      callback: function($$v) {
        _vm.$set(_vm.neuesDokument.data, "tag2", $$v)
      },
      expression: "neuesDokument.data.tag2"
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "hint": "Veranstaltungspunkte mit Enter trennen.",
      "outlined": "",
      "dense": "",
      "label": "Tag 2 Programm"
    },
    model: {
      value: (_vm.neuesDokument.data.tag2programm),
      callback: function($$v) {
        _vm.$set(_vm.neuesDokument.data, "tag2programm", $$v)
      },
      expression: "neuesDokument.data.tag2programm"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    staticClass: "pb-2",
    attrs: {
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "label": "Tag 3"
    },
    model: {
      value: (_vm.neuesDokument.data.tag3),
      callback: function($$v) {
        _vm.$set(_vm.neuesDokument.data, "tag3", $$v)
      },
      expression: "neuesDokument.data.tag3"
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "hint": "Veranstaltungspunkte mit Enter trennen.",
      "outlined": "",
      "dense": "",
      "label": "Tag 3 Programm"
    },
    model: {
      value: (_vm.neuesDokument.data.tag3programm),
      callback: function($$v) {
        _vm.$set(_vm.neuesDokument.data, "tag3programm", $$v)
      },
      expression: "neuesDokument.data.tag3programm"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "label": "Anmerkung"
    },
    model: {
      value: (_vm.neuesDokument.data.anmerkung),
      callback: function($$v) {
        _vm.$set(_vm.neuesDokument.data, "anmerkung", $$v)
      },
      expression: "neuesDokument.data.anmerkung"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.neuesDokument.art === 'tagesordnung') ? _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "label": "Überschrift"
    },
    model: {
      value: (_vm.neuesDokument.data.ueberschrift),
      callback: function($$v) {
        _vm.$set(_vm.neuesDokument.data, "ueberschrift", $$v)
      },
      expression: "neuesDokument.data.ueberschrift"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "label": "Freitext 1"
    },
    model: {
      value: (_vm.neuesDokument.data.freitext1),
      callback: function($$v) {
        _vm.$set(_vm.neuesDokument.data, "freitext1", $$v)
      },
      expression: "neuesDokument.data.freitext1"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.neuesDokument.data.tops.length + 1), function(index) {
    return _c('v-col', {
      key: index,
      staticClass: "pa-2",
      attrs: {
        "cols": "12"
      }
    }, [_c('v-text-field', {
      attrs: {
        "hide-details": "",
        "outlined": "",
        "dense": "",
        "prefix": 'TOP ' + index
      },
      model: {
        value: (_vm.neuesDokument.data.tops[index - 1]),
        callback: function($$v) {
          _vm.$set(_vm.neuesDokument.data.tops, index - 1, $$v)
        },
        expression: "neuesDokument.data.tops[index - 1]"
      }
    })], 1)
  }), _vm._v(" "), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "label": "Freitext 2"
    },
    model: {
      value: (_vm.neuesDokument.data.freitext2),
      callback: function($$v) {
        _vm.$set(_vm.neuesDokument.data, "freitext2", $$v)
      },
      expression: "neuesDokument.data.freitext2"
    }
  })], 1)], 2) : _vm._e(), _vm._v(" "), (_vm.neuesDokument.art === 'rundbriefohneansprache') ? _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "items": _vm.selectBbrBbr,
      "label": "Absender"
    },
    model: {
      value: (_vm.neuesDokument.data.absender),
      callback: function($$v) {
        _vm.$set(_vm.neuesDokument.data, "absender", $$v)
      },
      expression: "neuesDokument.data.absender"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "label": "Position"
    },
    model: {
      value: (_vm.neuesDokument.data.position),
      callback: function($$v) {
        _vm.$set(_vm.neuesDokument.data, "position", $$v)
      },
      expression: "neuesDokument.data.position"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "label": "Überschrift"
    },
    model: {
      value: (_vm.neuesDokument.data.ueberschrift),
      callback: function($$v) {
        _vm.$set(_vm.neuesDokument.data, "ueberschrift", $$v)
      },
      expression: "neuesDokument.data.ueberschrift"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "rows": "10",
      "label": "Freitext 1"
    },
    model: {
      value: (_vm.neuesDokument.data.freitext),
      callback: function($$v) {
        _vm.$set(_vm.neuesDokument.data, "freitext", $$v)
      },
      expression: "neuesDokument.data.freitext"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.neuesDokument.art === 'rundbrief160') ? _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "items": _vm.selectBbrBbr,
      "label": "Absender"
    },
    model: {
      value: (_vm.neuesDokument.data.absender),
      callback: function($$v) {
        _vm.$set(_vm.neuesDokument.data, "absender", $$v)
      },
      expression: "neuesDokument.data.absender"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "label": "Position"
    },
    model: {
      value: (_vm.neuesDokument.data.position),
      callback: function($$v) {
        _vm.$set(_vm.neuesDokument.data, "position", $$v)
      },
      expression: "neuesDokument.data.position"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "label": "Überschrift"
    },
    model: {
      value: (_vm.neuesDokument.data.ueberschrift),
      callback: function($$v) {
        _vm.$set(_vm.neuesDokument.data, "ueberschrift", $$v)
      },
      expression: "neuesDokument.data.ueberschrift"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "rows": "10",
      "label": "Freitext 1"
    },
    model: {
      value: (_vm.neuesDokument.data.freitext),
      callback: function($$v) {
        _vm.$set(_vm.neuesDokument.data, "freitext", $$v)
      },
      expression: "neuesDokument.data.freitext"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.printDokument()
      }
    }
  }, [_vm._v("Drucken")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showNeuesDokument = false
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), (_vm.isNew) ? _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.createDokument()
      }
    }
  }, [_vm._v("Speichern")]) : _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.updateDokument()
      }
    }
  }, [_vm._v("Speichern")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d2f6cb0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/dokumente.vue
// module id = 750
// module chunks = 15